import React, { useState, useEffect } from "react";
import axios from "axios";

const Garageterms = () => {
  // Get garage_id from localStorage
  const server_url = localStorage.getItem("server_url");
  const [autoOpenModal, setAutoOpenModal] = useState(false);
  const garageId =
    localStorage.getItem("grage_id") || localStorage.getItem("garage_id");

  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editingTerm, setEditingTerm] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
  });

  // Check if garage_id exists
  useEffect(() => {
    if (!garageId) {
      alert("Garage ID not found. Please log in again.");
      return;
    }
    fetchTerms();
  }, []);

  const fetchTerms = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("type", 1);
      formData.append("garage_id", garageId);
      const response = await axios.post(`${server_url}garage_tc.php`, formData);

      if (response.data.status === 1) {
        setTerms(response.data.data || []);
      } else {
        console.error("Error fetching terms:", response.data.message);
        setTerms([]);
      }
    } catch (error) {
      console.error("Error:", error);
      setTerms([]);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddNew = () => {
    setEditingTerm(null);
    setFormData({
      title: "",
    });
    setShowModal(true);
  };

  const handleEdit = (term) => {
    setEditingTerm(term);
    setFormData({
      title: term.garage_tc_title,
    });
    setShowModal(true);
  };

  const handleDelete = (term) => {
    setEditingTerm(term);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      const formData = new FormData();
      formData.append("type", 4);
      formData.append("term_id", editingTerm.garage_tc_id);

      const response = await axios.post(`${server_url}garage_tc.php`, formData);

      if (response.data.status === 1) {
        fetchTerms();
        setShowDeleteModal(false);
        setEditingTerm(null);
      } else {
        alert("Failed to delete term: " + response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error deleting term");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      alert("Title is required");
      return;
    }

    try {
      const apiFormData = new FormData();

      if (editingTerm) {
        apiFormData.append("type", 3);
        apiFormData.append("term_id", editingTerm.garage_tc_id);
      } else {
        apiFormData.append("type", 2);
        apiFormData.append("garage_id", garageId);
      }

      apiFormData.append("title", formData.title);

      const response = await axios.post(
        `${server_url}garage_tc.php`,
        apiFormData
      );

      if (response.data.status === 1) {
        fetchTerms();
        setShowModal(false);
        setFormData({ title: "" });
        setEditingTerm(null);
      } else {
        alert("Operation failed: " + response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error saving term");
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  if (!garageId) {
    return (
      <div className="history-container">
        <div className="content-area">
          <div className="no-vehicles section-home">
            <div className="no-vehicles-icon">🚫</div>
            <div className="no-vehicles-title">Garage ID Not Found</div>
            <div className="no-vehicles-text">
              Please log in again to access garage terms and conditions.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="history-container">
      {/* Sticky Header Section */}

      {/* Content Area */}
      <div className="content-area">
        {/* Terms List */}
        <div className="home-vehicles">
          {loading ? (
            <div className="loading-vehicles">
              <div className="loading-spinner"></div>
              <div>Loading terms...</div>
            </div>
          ) : terms.length > 0 ? (
            <div className="vehicles-list home-icon">
              {terms.map((term, index) => (
                <div
                  key={term.garage_tc_id}
                  className="vehicle-card section-home"
                >
                  <div className="vehicle-header">
                    <table style={{ width: "100%", textAlign: "left" }}>
                      <tbody>
                        {/* Term Title and Delete Button */}
                        <tr>
                          <td
                            onClick={() => handleEdit(term)}
                            style={{
                              width: "85%",
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                          >
                            {term.garage_tc_title || "N/A"}
                          </td>
                          <td style={{ textAlign: "right", width: "15%" }}>
                            <button
                              onClick={() => handleDelete(term)}
                              style={{
                                background: "transparent",
                                border: "none",
                                color: "#DB4437",
                                cursor: "pointer",
                                padding: "4px 8px",
                                borderRadius: "4px",
                              }}
                              title="Delete term"
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>

                        {/* Created Date */}
                        {/* <tr>
                          <td
                            colSpan="2"
                            style={{ fontSize: "12px", color: "#666" }}
                          >
                            <i
                              className="far fa-calendar"
                              style={{ marginRight: "4px" }}
                            ></i>
                            Created: {formatDate(term.c_date)}
                          </td>
                        </tr> */}

                        {/* Edit Button Row */}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-vehicles section-home">
              <div className="no-vehicles-icon">📝</div>
              <div className="no-vehicles-title">No Terms Found</div>
              <div className="no-vehicles-text">
                Add your first term by clicking the "+" button below
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Floating Add Button */}
      <div className="floating-add-btn" onClick={handleAddNew}>
        <i className="fas fa-plus"></i>
      </div>

      {/* Add/Edit Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "400px",
              padding: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#2d3748",
                }}
              >
                {editingTerm ? "Edit Term" : "Add New Term"}
              </h3>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#718096",
                }}
              >
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#4a5568",
                  }}
                >
                  Title *
                </label>
                <textarea
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "2px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                    outline: "none",
                    resize: "vertical", // allow resizing if needed
                  }}
                  placeholder="Enter term title"
                  required
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "12px",
                }}
              >
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  style={{
                    padding: "10px 20px",
                    border: "2px solid #e2e8f0",
                    background: "white",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    padding: "10px 20px",
                    background: "#0352a1",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  {editingTerm ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "350px",
              padding: "24px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                margin: "0 auto 20px",
                backgroundColor: "#fee2e2",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="fas fa-exclamation-triangle"
                style={{ fontSize: "24px", color: "#dc2626" }}
              ></i>
            </div>

            <h3
              style={{
                margin: "0 0 12px 0",
                fontSize: "18px",
                fontWeight: "600",
                color: "#1f2937",
              }}
            >
              Delete Term
            </h3>
            <p
              style={{
                margin: "0 0 24px 0",
                color: "#6b7280",
                fontSize: "14px",
              }}
            >
              Are you sure you want to delete "{editingTerm?.garage_tc_title}"?
              This action cannot be undone.
            </p>

            <div style={{ display: "flex", gap: "12px" }}>
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setEditingTerm(null);
                }}
                style={{
                  flex: 1,
                  padding: "12px",
                  border: "2px solid #e2e8f0",
                  background: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: "#dc2626",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .history-container {
          min-height: 100vh;
          background: white;
          padding: 0;
          position: relative;
        }

        /* Sticky Filter Styles */
        .sticky-filter {
          position: sticky;
          top: 0;
          z-index: 100;
          background: white;
          padding: 8px 0;
          border-bottom: 1px solid #e2e8f0;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .content-area {
          padding-top: 8px; /* Reduced padding since filter is sticky */
        }

        /* Search/Filters Section */
        .home-icon .section-home {
          padding: 8px 12px 12px 12px;
        }
        .home-icon {
          padding-left: 0px;
          padding-right: 0px;
        }

        /* Heading Section */
        .heading-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          padding: 0 20px;
        }

        .sa-title {
          font-size: 18px;
          font-weight: 600;
          color: #2d3748;
        }

        /* Vehicles List */
        .home-vehicles {
          padding: 10px;
        }

        .loading-vehicles {
          text-align: center;
          padding: 40px 20px;
          color: #666;
        }

        .loading-spinner {
          width: 30px;
          height: 30px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #0352a1;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 15px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .vehicles-list {
          display: grid;
          gap: 15px;
        }

        .vehicle-card {
          background: #f8f9fa;
          border-radius: 12px;
          padding: 16px;
          border-left: 4px solid #0352a1;
          transition: all 0.3s ease;
        }

        .vehicle-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .vehicle-header {
          width: 100%;
        }

        .vehicle-header table {
          width: 100%;
          border-collapse: collapse;
        }

        .vehicle-header td {
          padding: 4px 0;
          vertical-align: top;
        }

        /* No Vehicles State */
        .no-vehicles {
          text-align: center;
          padding: 40px 20px;
          background: #f8f9fa;
          border-radius: 12px;
          margin: 20px 0;
        }

        .no-vehicles-icon {
          font-size: 48px;
          margin-bottom: 15px;
        }

        .no-vehicles-title {
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 8px;
        }

        .no-vehicles-text {
          color: #666;
          margin-bottom: 20px;
        }

        /* Floating Add Button */
        .floating-add-btn {
          position: fixed;
          bottom: 80px;
          right: 20px;
          width: 60px;
          height: 60px;
          background: #0352a1;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(3, 82, 161, 0.3);
          z-index: 99;
          transition: all 0.3s ease;
          border: none;
        }

        .floating-add-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 16px rgba(3, 82, 161, 0.4);
        }

        .floating-add-btn:active {
          transform: scale(0.95);
        }

        @media (max-width: 768px) {
          .content-area {
            padding-top: 6px;
          }

          .heading-section {
            padding: 0 15px;
          }

          .home-vehicles {
            padding: 10px;
          }

          .vehicle-card {
            padding: 12px;
          }

          .vehicle-header td {
            font-size: 14px;
          }

          .sticky-filter {
            padding: 6px 0;
          }

          .floating-add-btn {
            bottom: 70px;
            right: 15px;
            width: 56px;
            height: 56px;
            font-size: 22px;
          }
        }

        @media (max-width: 480px) {
          .heading-section {
            flex-direction: column;
            gap: 8px;
            align-items: flex-start;
          }

          .sticky-filter {
            padding: 4px 0;
          }

          .floating-add-btn {
            bottom: 60px;
            right: 12px;
            width: 52px;
            height: 52px;
            font-size: 20px;
          }
        }

        /* Animation for floating button */
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-5px);
          }
          100% {
            transform: translateY(0px);
          }
        }

        .floating-add-btn {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Garageterms;
